import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import GlobalHeader from '../Admin/GlobalHeader';
import SplashScreen from '../Common/SplashScreen';
import CommandPalette from '../CommandPalette';
import { useAuth } from '../../context/AuthContext';
import { SupportDashboardProvider } from '../../context/SupportDashboardContext';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showSplash, setShowSplash] = useState(true);
  const { user } = useAuth();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  useEffect(() => {
    setShowSplash(true);
  }, []);

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <SupportDashboardProvider>
      <div className="flex h-screen overflow-hidden bg-gradient-to-br from-gray-50 via-primary-50/20 to-secondary-50/20 dark:from-[#00152E] dark:via-[#002147] dark:to-[#00152E] transition-colors duration-300 relative">
        <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
          <div className="absolute top-0 right-0 w-96 h-96 bg-primary-200/30 dark:bg-primary-800/10 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-15 dark:opacity-20 animate-float"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary-200/30 dark:bg-secondary-800/10 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-15 dark:opacity-20 animate-float" style={{ animationDelay: '2s' }}></div>
          <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-accent-200/20 dark:bg-accent-800/10 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-10 dark:opacity-20 animate-float" style={{ animationDelay: '4s' }}></div>
        </div>

        <Sidebar
          isOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="flex-1 flex flex-col overflow-hidden relative z-10">
          <GlobalHeader onMenuToggle={toggleSidebar} isSidebarOpen={sidebarOpen} />

          <main className="flex-1 overflow-y-auto p-4 lg:p-6 animate-fade-in scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            <Outlet />
          </main>
        </div>

        <CommandPalette />
      </div>
    </SupportDashboardProvider>
  );
};

export default MainLayout;